<template>
	<div class="ocean" :style="{ backgroundColor: bgColor, height: height + 'px' }">
		<div
			v-for="(a, index) in amount"
			:key="index"
			class="wave"
			:style="{ height: height + 'px', opacity: a / amount, backgroundImage: svg }"
		></div>
	</div>
</template>
<script>
export default {
	name: 'Wave',
	props: {
		level: {
			type: Number,
			required: true,
		},
		bgColor: {
			type: String,
			required: true,
		},
		height: {
			type: Number,
			default: 150,
		},
		amount: {
			type: Number,
			default: 1,
		},
	},
	computed: {
		svg() {
			return `url("/img/wave${this.level}.svg")`;
		},
	},
};
</script>
<style>
.ocean {
	position: relative;
	overflow: hidden;
}
.wave {
	width: 6400px;
	background-repeat: repeat-x;
	animation: wave 30s cubic-bezier(0.36, 0.45, 0.63, 0.53) infinite;
	transform: translate3d(0, 0, 0);
	position: absolute;
	top: 0;
}

.wave:nth-of-type(2) {
	background-position-x: 10%;
	animation: wave 15s cubic-bezier(0.36, 0.45, 0.63, 0.53) infinite;
	/* animation: wave 20s cubic-bezier(0.36, 0.45, 0.63, 0.53) -0.125s infinite, swell 7s ease -1.25s infinite; */
}

@keyframes wave {
	0% {
		margin-left: 0;
	}
	100% {
		margin-left: -1600px;
	}
}

/* @keyframes swell {
	0%,
	100% {
		transform: translate3d(0, -25px, 0);
	}
	50% {
		transform: translate3d(0, 5px, 0);
	}
} */
</style>
